import type { Logger } from '@vp/ubik-logging'

import type { WorkId } from '../../types/WorkId'

/**
 * Determines which cart API to call based on number of work IDs
 * Pure function for easier testing
 *
 * @param workIds - Array of work IDs to add to cart
 * @param culture - Culture code for localization
 * @param upsertCartAsync - Function to upsert single work to cart
 * @param upsertCartMultiWorkAsync - Function to upsert multiple works to cart
 */
export async function upsertWorkToCart(
  workIds: string[],
  culture: string,
  upsertCartAsync: (workId: WorkId, culture: string, authorizationHeader: string | undefined, logger: Logger) => Promise<void>,
  upsertCartMultiWorkAsync: (workIds: string[], culture: string, authorizationHeader: string | undefined, logger: Logger) => Promise<void>,
  authorizationHeader: string | undefined,
  logger: Logger,
): Promise<void> {
  if (workIds.length > 1) {
    await upsertCartMultiWorkAsync(workIds, culture, authorizationHeader, logger)
  } else if (workIds.length === 1) {
    await upsertCartAsync(workIds[0]!, culture, authorizationHeader, logger)
  }
}
